// extracted by mini-css-extract-plugin
export default {"ProfileDocuments":"UqTLjO8ihT","Row":"WL9zsZczCT"};